import React, { useState } from "react";
import Card from "components/card";
import { toast, Toaster } from "react-hot-toast";
import { MdUpload, MdCheckCircle, MdError, MdDownload } from "react-icons/md";

const BulkCalibrate = () => {
  const [file, setFile] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    if (selectedFile) {
      if (selectedFile.type !== "text/csv") {
        toast.error("Please upload a CSV file", {
          icon: <MdError className="text-red-500" />,
          style: {
            background: "#FEE2E2",
            color: "#991B1B",
            border: "1px solid #FECACA",
          },
        });
        return;
      }
      setFile(selectedFile);
      toast.success("File selected successfully", {
        icon: <MdCheckCircle className="text-green-500" />,
        style: {
          background: "#D1FAE5",
          color: "#065F46",
          border: "1px solid #A7F3D0",
        },
      });
    }
  };

  const handleUpload = async (e) => {
    e.preventDefault();
    if (!file) {
      toast.error("Please select a file to upload", {
        icon: <MdError className="text-red-500" />,
        style: {
          background: "#FEE2E2",
          color: "#991B1B",
          border: "1px solid #FECACA",
        },
      });
      return;
    }

    setIsLoading(true);
    const loadingToast = toast.loading("Uploading file...", {
      style: {
        background: "#EFF6FF",
        color: "#1E40AF",
        border: "1px solid #BFDBFE",
      },
    });

    try {
      const formData = new FormData();
      formData.append('file', file);

      const response = await fetch("https://usibras-web-backend.onrender.com/api/calibration-data", {
        method: "POST",
        body: formData
      });

      const result = await response.json();
      console.log("API Response:", result);

      if (!response.ok) {
        throw new Error(result.error || `Upload failed with status: ${response.status}`);
      }

      toast.dismiss(loadingToast);
      toast.success(result.message || "File uploaded successfully", {
        icon: <MdCheckCircle className="text-green-500" />,
        style: {
          background: "#D1FAE5",
          color: "#065F46",
          border: "1px solid #A7F3D0",
        },
        duration: 5000,
      });
      
      setFile(null);
    } catch (error) {
      console.error("Upload Error:", error);
      toast.dismiss(loadingToast);
      toast.error(error.message || "Failed to upload file. Please check the console for details.", {
        icon: <MdError className="text-red-500" />,
        style: {
          background: "#FEE2E2",
          color: "#991B1B",
          border: "1px solid #FECACA",
        },
        duration: 5000,
      });
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mt-5 h-full">
      <Toaster position="top-right" />
      <Card extra={"w-full p-6 shadow-lg"}>
        <div className="mb-8 w-full">
          <div className="flex items-center justify-between">
            <div>
              <h4 className="text-2xl font-bold text-navy-700 dark:text-white">
                Bulk Calibration Upload
              </h4>
              <p className="mt-2 text-base text-gray-600">
                Upload a CSV file containing calibration records.
              </p>
            </div>
            <a
              href="/assets/templates/calibration_data_template.csv"
              download="calibration_data_template.csv"
              className="flex items-center gap-2 rounded-lg bg-brand-500 px-4 py-2 text-sm font-medium text-white shadow-md hover:bg-brand-600 transition-all duration-200"
            >
              <MdDownload className="h-5 w-5" />
              Download Template
            </a>
          </div>
        </div>

        <form onSubmit={handleUpload} className="space-y-8">
          {/* File Upload Section */}
          <div className="rounded-xl border-2 border-dashed border-gray-300 p-8 dark:border-navy-700 bg-white dark:bg-navy-800 shadow-sm hover:shadow-md transition-all duration-200">
            <div className="flex flex-col items-center justify-center">
              <div className="rounded-full bg-brand-50 p-4 dark:bg-navy-700 mb-4">
                <MdUpload className="h-8 w-8 text-brand-500" />
              </div>
              <p className="text-sm text-gray-600 dark:text-gray-300 mb-4">
                Drag and drop your CSV file here, or click to select
              </p>
              <input
                type="file"
                accept=".csv"
                onChange={handleFileChange}
                className="hidden"
                id="file-upload"
              />
              <label
                htmlFor="file-upload"
                className="cursor-pointer rounded-lg bg-brand-500 px-6 py-2.5 text-sm font-medium text-white shadow-md hover:bg-brand-600 transition-all duration-200"
              >
                Select File
              </label>
              {file && (
                <p className="mt-4 text-sm text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-navy-700 px-4 py-2 rounded-lg">
                  Selected file: {file.name}
                </p>
              )}
            </div>
          </div>

          {/* Upload Button */}
          <div className="flex justify-end">
            <button
              type="submit"
              disabled={!file || isLoading}
              className={`rounded-lg px-6 py-2.5 text-sm font-medium text-white shadow-md transition-all duration-200 ${
                !file || isLoading
                  ? "cursor-not-allowed bg-gray-400"
                  : "bg-brand-500 hover:bg-brand-600"
              }`}
            >
              {isLoading ? "Uploading..." : "Upload File"}
            </button>
          </div>
        </form>
      </Card>
    </div>
  );
};

export default BulkCalibrate; 